import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Venta } from 'src/app/model/index.model';
import { VentaService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';

@Component({
  selector: 'app-estado-venta',
  templateUrl: './estado-venta.component.html',
  styleUrls: ['./estado-venta.component.scss']
})
export class EstadoVentaComponent implements OnInit {

  estados: string[] = ['aceptada', 'confirmada', 'despachada', 'rechazada'];
  estadoSel: 'pedida';

  @Input() item: Venta;
  proccess: boolean = false



  constructor(
    public activeModal: NgbActiveModal,
    public wsdl: VentaService
  ) {

  }


  ngOnInit() {
  }

  async doAction() {
    try {
      this.proccess = true;
      this.item.estado = this.estadoSel
      console.log(this.item)
      const res = await this.wsdl.doUpdate(this.item, this.item.id).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        UturuncoUtils.showToas("Se actualizado correctemte", "success");
        this.activeModal.close();
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    } finally {
      this.proccess = false;
    }


  }

}
